import HttpRequest from "@/services/http_request";

class ClassProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_ENDPOINT);
  }

  async getClassReserve(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classreserve/classreserve");
    const { data } = res.data;
    return data;
  }

  async getClassReservePre(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classreserve/classreservepre");
    const { data } = res.data;
    return data;
  }

  async isClassReserve(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      classid: this.variableParser(request.classid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const { data } = await this.get("reg/time/classreserve/isclassreserve");
    return data;
  }

  async searchOpenCourse(payload) {
    const { token, request } = payload;
    const param = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursegroup: this.variableParser(request.coursegroup),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      lang: this.variableParser(request.lang)
    };
    if (request.coursecode != undefined) {
      param["coursecode"] = this.variableParser(request.coursecode);
    }
    if (request.coursename != undefined) {
      param["coursename"] = this.variableParser(request.coursename);
    }
    if (request.studentid != undefined) {
      param["studentid"] = this.variableParser(request.studentid);
    }
    if (request.structure != undefined) {
      param["structure"] = this.variableParser(request.structure);
    }
    this.setHeaderBearerAuth(token);
    const res = await this.create("reg/time/classresult", param);
    const { data } = res.data;
    return data;
  }

  async searchPreOpenCourse(payload) {
    const { token, request } = payload;
    const param = {
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      levelid: this.variableParser(request.levelid),
      coursegroup: this.variableParser(request.coursegroup),
      facultyid: this.variableParser(request.facultyid),
      departmentid: this.variableParser(request.departmentid),
      studentid: this.variableParser(request.studentid),
      structure: this.variableParser(request.structure),
      lang: this.variableParser(request.lang)
    };
    if (request.coursecode != undefined) {
      param["coursecode"] = this.variableParser(request.coursecode);
    }
    if (request.coursename != undefined) {
      param["coursename"] = this.variableParser(request.coursename);
    }
    this.setHeaderBearerAuth(token);
    const res = await this.create("reg/time/classpreresult", param);
    const { data } = res.data;
    return data;
  }

  async getClassDetail(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classdetail");
    const { data } = res.data;
    return data;
  }

  async getSemesterPlanByStudentId(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      studentid: this.variableParser(request.studentid),
      programid: this.variableParser(request.programid),
      studyplanid: this.variableParser(request.studyplanid),
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/academic/studyplan");
    const { data } = res.data;
    // const data = [
    //   {
    //     COURSECODE: "1004212",
    //     COURSENAME: "องค์การสหประชาชาติและองค์การพหุภาคีการพัฒนาระหว่างประเทศ",
    //     COURSEUNIT: "3(3-0-6)",
    //     GRADEMODE: "A-F",
    //     PROGRAMID: 583180600,
    //     STUDENTYEAR: 4,
    //     SEMESTER: 1,
    //     COURSEID: 1705218890,
    //     STUDYPLANID: 583180601
    //   },
    //   {
    //     COURSECODE: "1004231",
    //     COURSENAME: "การสื่อสาร กระบวนการสร้างประชาธิปไตยกับการพัฒนา",
    //     COURSEUNIT: "3(3-0-6)",
    //     GRADEMODE: "A-F",
    //     PROGRAMID: 583180600,
    //     STUDENTYEAR: 4,
    //     SEMESTER: 1,
    //     COURSEID: 1705218890,
    //     STUDYPLANID: 583180601
    //   },
    //   {
    //     COURSECODE: "1004252",
    //     COURSENAME: "เศรษฐศาสตร์ของบริษัทข้ามชาติ",
    //     COURSEUNIT: "3(3-0-6)",
    //     GRADEMODE: "A-F",
    //     PROGRAMID: 583180600,
    //     STUDENTYEAR: 4,
    //     SEMESTER: 1,
    //     COURSEID: 1705218890,
    //     STUDYPLANID: 583180601
    //   }
    // ];
    return data;
  }

  async getPreClassTime(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      firstdate: this.variableParser(request.firstdate),
      lastdate: this.variableParser(request.lastdate),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classtime/classtimepre");
    const { data } = res.data;
    return data;
  }

  async getPreExamTime(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/examtimepre");
    const { data } = res.data;
    return data;
  }

  async getFinance(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("finances/invoice");
    const { data } = res.data;
    return data;
  }

  async getCourseAllByClassId(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/courseallbyclassid");
    const { data } = res.data;
    return data;
  }

  async getClassReserveByStudent(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classreserve/student");
    const { data } = res.data;
    return data;
  }

  async getClassReserveByStudyplan(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classreserve/studyplan");
    const { data } = res.data;
    return data;
  }

  async getClassReserveByFaculty(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      classid: this.variableParser(request.classid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classreserve/faculty");
    const { data } = res.data;
    return data;
  }

  async getClassTime(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      firstdate: this.variableParser(request.firstdate),
      lastdate: this.variableParser(request.lastdate),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/classtime/classtime");
    const { data } = res.data;
    return data;
  }

  async getExamTime(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("reg/time/examtime");
    const { data } = res.data;
    return data;
  }

  async genqrcode(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      suffix: "00",
      lang: this.variableParser(request.lang)
    });
    const res = await this.getBlob(
      `finances/genqrcode?timestamp=${new Date().getTime()}`
    );
    return res;
  }

  async getClassTimeSubmit(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      firstdate: this.variableParser(request.firstdate),
      lastdate: this.variableParser(request.lastdate),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("/reg/time/classtime/classtimesubmit");
    const { data } = res.data;
    return data;
  }

  async geExamtimeSubmit(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("/reg/time/examtimesubmit");
    const { data } = res.data;
    return data;
  }

  async getSubmitFee(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      studentid: this.variableParser(request.studentid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("finances/submitfee");
    const { data } = res.data;
    return data;
  }

  async getsectionForB5(payload) {
    const { token, request } = payload;
    this.setHeader({
      Authorization: `Bearer ${this.variableParser(token)}`,
      acadyear: this.variableParser(request.acadyear),
      semester: this.variableParser(request.semester),
      courseid: this.variableParser(request.courseid),
      lang: this.variableParser(request.lang)
    });
    const res = await this.get("/reg/enroll/report/B5getsection");
    const { data } = res.data;
    return data;
  }
}

export default ClassProvider;
